module.exports = __webpack_public_path__ + "479794431bfe4a96b90adaed2040793d.pdf";